jQuery( function ($) {

    
    // improved gform ajax spinner
    $(document).on( 'submit', '.gform_wrapper form', function () {
        let $button = $( 'button[type=submit]', this );
        if ( !$button.length ) { return; }
        $button.attr( 'disabled', true );
        $button.attr( 'aria-disabled', 'true' );
        $button.addClass( 'is-ajax-submitting' );
    });


    function init_select2 ( element ) {
        let $element = $(element);
        let $gf_placeholder = $( 'option.gf_placeholder', $element );
        if ( $gf_placeholder.length ) {
            $element.attr( 'data-placeholder', $gf_placeholder.text() );
            $gf_placeholder.html('').removeClass( 'gf_placeholder' );
        }
        $element.select2({
            minimumResultsForSearch: 5,
            closeOnSelect: $(element).data().close_on_select ?? true,
            allowClear: $element.attr( 'aria-required' ) != 'true',
        });
    }


    $( 'select:not(#my-calendar-year):not(#my-calendar-month)' ).each( function () {
        init_select2( this );
    });


    $(document).on( 'gform_post_render', function ( e, form_id, current_page ) {
        const $form = `#gform_${ form_id }`;
        $( 'select', $form ).each( function () {
            init_select2( this );
        });
        gform_observer.observe( $( '.gform_fields', $form ).get(0) );
    });


    const gform_observer = new ResizeObserver( entries => {
        for ( let entry of entries ) {
          set_inline_submit_styles( $( entry.target ) );
          $( '.gfield_error', entry.target ).each( set_error_position );
        }
    });

    function set_inline_submit_styles ( $gfields ) {
        const $submit = $( '.gfield--width-fill + .gfield--type-submit', $gfields );
        if ( $submit.length ) {
            const $filled = $submit.prev();
            $filled.toggleClass( 'btn-inline', ( $submit.get(0).offsetTop == $filled.get(0).offsetTop ) );
        }
    }

    // scoped to .gfield
    function set_error_position () {
        $(this).css( '--input-container-top', `${ $( '.ginput_container', this ).get(0).offsetTop }px` );
    }


});